module.exports = __webpack_public_path__ + "img/home-featured-collection-1.d26ddaa6.jpg";